import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Loader2, Lock, ArrowLeft } from "lucide-react";

function formatError(detail) {
  if (!detail) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return String(detail);
}

const AdminLogin = () => {
  const { login, admin, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatError(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1121] flex items-center justify-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-[0.12]" />
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-[#001489] rounded-full blur-[120px] opacity-40" />
      <a href="/" data-testid="back-to-site"
        className="absolute top-6 left-6 flex items-center gap-2 text-white/60 hover:text-white text-sm transition-colors">
        <ArrowLeft size={16} /> Retour au site
      </a>
      <div className="relative w-full max-w-md bg-white/70 backdrop-blur-xl border border-white/20 rounded-3xl p-8 sm:p-10 shadow-2xl">
        <div className="w-12 h-12 rounded-xl bg-[#0B1121] flex items-center justify-center">
          <Lock className="text-white" size={22} />
        </div>
        <h1 className="mt-5 font-display font-black tracking-tighter text-3xl text-[#0B1121]">
          Espace administration
        </h1>
        <p className="mt-2 text-slate-600">Consultation des soutiens, messages et dons.</p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <Input required type="email" data-testid="admin-email" className="h-12 bg-white"
            placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Input required type="password" data-testid="admin-password" className="h-12 bg-white"
            placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full h-13 py-3.5 bg-[#0B1121] text-white font-semibold rounded-xl hover:bg-[#001489] transition-all disabled:opacity-60 flex items-center justify-center gap-2">
            {loading ? <Loader2 className="animate-spin" size={20} /> : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
